export const DEFAULT_DEV_BASE_URL = '/api/v1'
export const DEFAULT_PROD_BASE_URL = 'https://api.emisenv.com:5336/api/v1'
export const DEFAULT_REQUEST_TIMEOUT = 30 * 1000
export const LONG_REQUEST_TIMEOUT = 120 * 1000

export function isDevelopmentEnv() {
  return process.env.NODE_ENV === 'development'
}

// Vue CLI 场景下优先读取环境变量；未配置时继续回落到项目原有默认值，
// 这样既能支持按环境部署，也不会破坏当前开发/生产行为。
export function resolveApiBaseUrl() {
  const devBaseUrl = process.env.VUE_APP_API_BASE_URL || DEFAULT_DEV_BASE_URL
  const prodBaseUrl = process.env.VUE_APP_API_BASE_URL_PROD || DEFAULT_PROD_BASE_URL

  return isDevelopmentEnv() ? devBaseUrl : prodBaseUrl
}

// 统一拼接请求地址；如果上层已经传入绝对地址，则直接透传，
// 避免下载类或特殊场景再次被重复拼接 baseUrl。
export function buildApiUrl(url = '') {
  if (/^https?:\/\//.test(url)) {
    return url
  }

  // 允许后端返回 /api/... 形式的完整相对接口；生产部署需保证同源 /api 反向代理存在。
  if (/^\/api\//.test(url)) {
    return url
  }

  return `${resolveApiBaseUrl()}${url}`
}

// 所有超时值最终都在这里兜底归一，避免调用方传入非法值后把 axios 配置打坏。
export function resolveRequestTimeout(timeout = DEFAULT_REQUEST_TIMEOUT) {
  const normalizedTimeout = Number(timeout)

  // Axios 约定 timeout=0 表示不设置前端超时，适用于后端通过心跳维持的长任务请求。
  if (normalizedTimeout === 0) {
    return 0
  }

  if (Number.isFinite(normalizedTimeout) && normalizedTimeout > 0) {
    return normalizedTimeout
  }

  return DEFAULT_REQUEST_TIMEOUT
}

export default {
  // 接口域名
  baseUrl: DEFAULT_DEV_BASE_URL,
  baseUrlPro: DEFAULT_PROD_BASE_URL,
  defaultTimeout: DEFAULT_REQUEST_TIMEOUT,
  longTimeout: LONG_REQUEST_TIMEOUT
}
